<div *ngIf="(imports$ | async)!.length >0" class="page_container">
    <table class="listing_table">
        <thead class="header_stiky">
            <tr class="head_table">
                <th>{{"import.file_name"| translate}}</th>
                <th>{{"common.total_products"| translate}}</th>
                <th>{{"common.date_time"| translate}}</th>
                <th>{{"import.file_dowload"| translate}}</th>
                <th>
                    {{"common.status"|translate}}
                </th>
            </tr>
        </thead>
        <tbody class="scrollable-body">
            <ng-container *ngFor="let import of imports$ | async; let i = index">
                <tr class="body_table hover_tr cursor" *ngIf="import.validated">
                    <td  (click)="details(import.id, import.validated)">
                        <span class="bold_span">{{import.file_name}}</span>
                    </td>
                    <td  (click)="details(import.id, import.validated)" class="td_block cursor">
                        <span class="bold_span">{{import.nbr_products}}</span>
                    </td>
                    <td class="td_block">
                        <span class="bold_span ng-star-inserted">{{import.date | adaptToUserUtcOffset | date: DATE_FORMAT }}</span><br/>
                    </td>
                    <td>
                        <button class="td_block" (click)="downloadFile(import)">
                            <img class="listing_image files" src="assets/icones/xls.svg" alt=""><br />
                            <span class="descr_elemnt bold_span" style="text-align: center;">
                                {{ '.Xls' }}
                            </span>
                        </button>
                    </td>
                    <td>
                        <span class="item_tag_status"
                            [class]="import.committed ? 'imported' : 'draft'">
                            {{import.committed ? ('import.status.Imported'| translate): ('import.status.Draft'| translate)}}
                        </span>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <app-pagination [pagination]="pagination$ | async" (toPageEvent)="toPage($event)"></app-pagination>
</div>
<div *ngIf="filter && (imports$ | async)!.length === 0  && !(isAppLoading$ | async)" class="no_reseult">
    <ng-container *ngIf="filter?.filters!.length === 0 && !key">
      <img src="../../../../../assets/icones/no-import.svg" alt="">
      <h3>{{"import.no_import" | translate}}</h3>
    </ng-container>
    <ng-container *ngIf="filter?.filters!.length > 0 || key">
      <img class="no_intense" src="../../../../../assets/icones/no-result-search.svg" alt="">
      <h3>{{"import.no_data_search" | translate }}</h3>
    </ng-container>
    <button *ngIf="filter?.filters!.length === 0 && !key" class="save_btn_pop_up blue_btn" data-testid="imports-import-btn" (click)="import()">
        <span>{{"common.add" | translate | uppercase}}</span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
</div>